"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isModuleCorrect_1 = __importDefault(require("../utils/isModuleCorrect"));
function updateModulesCorrect({ sessionModulesCorrect, sectionId }, sessionEvent) {
    const { modules } = sessionEvent;
    return (sessionModulesCorrect +
        modules.filter(module => module.sectionId === sectionId && (0, isModuleCorrect_1.default)(module)).length);
}
exports.default = updateModulesCorrect;
